import { render } from "./help-content.vue?vue&type=template&id=3800c719&scoped=true"
import script from "./help-content.vue?vue&type=script&lang=js"
export * from "./help-content.vue?vue&type=script&lang=js"

import "./help-content.vue?vue&type=style&index=0&id=3800c719&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3800c719"]])

export default __exports__